import { Component, OnInit } from '@angular/core';
import { AuthHelperService } from 'src/app/services/auth-helper.service';
import { RmDateRangeServiceService } from 'src/app/services/rm-date-range-service.service';
import { Employee, EmployeeGenSvc, ReportGenSvc, ReportTileViewModel, SystemSettingGenSvc } from 'src/app/services_autogenerated/generated_services';

@Component({
    selector: 'app-report-dashboard',
    templateUrl: './report-dashboard.component.html',
    styleUrls: ['./report-dashboard.component.css'],
    standalone: false
})
export class ReportDashboardComponent implements OnInit {

  public loggedInEmployee: Employee;
  public canViewDataAs: boolean;

  public employee: Employee;
  public filterEmployee: Employee;
  public isLoading: boolean = true;

  public completedPaidTotalColor = 'rgb(99,115,86)';
  public backlogTotalColor = 'rgb(154,118,164)';
  public commissionLostColor = 'rgb(171,113,112)'
  public pastDueColor = 'rgb(154,153,109)'

  public wellnessWorkHourAverageGoal: number;
  public workWorkHourAverageGoal: number;

  public filterStartDate: Date;
  public filterEndDate: Date;

  public startDate: Date;
  public endDate: Date;

  public assignedReports: ReportTileViewModel[];

  public employees: Employee[];

  constructor(
    private authHelperService: AuthHelperService, 
    private employeeService: EmployeeGenSvc, 
    private systemSettingService: SystemSettingGenSvc,
    private reportService: ReportGenSvc,
    private rmDateRangeService: RmDateRangeServiceService
  ) { }

  ngOnInit() {
    const loggedInEmployeeId = this.authHelperService.getDecodedAccessToken().id;

    this.filterStartDate = new Date(new Date().getFullYear(), 0, 1);
    this.filterEndDate = new Date();

    this.systemSettingService.getWellnessWorkHourAverageGoal().subscribe(res => this.wellnessWorkHourAverageGoal = +res.value);
    this.systemSettingService.getWorkWorkHourAverageGoal().subscribe(res => this.workWorkHourAverageGoal = +res.value);

    this.employeeService.getRegionalManagers().subscribe(res => {
      this.employees = res;
    });

    this.employeeService.get(loggedInEmployeeId).subscribe(res => {
      this.employee = res;
      this.loggedInEmployee = res;

      this.reportService.getEmployeeAssignedReports(loggedInEmployeeId).subscribe(res => {
        this.canViewDataAs = res.some(rpt => rpt.companyWide);
        this.assignedReports = res;
        this.isLoading = false;
      });
    });
  }

  filter() {
    this.isLoading = true;
    if (this.filterEmployee) {
      this.employee = this.filterEmployee
    } else {
      this.employee = this.loggedInEmployee;
    }
    this.reportService.getEmployeeAssignedReports(this.employee.id).subscribe(res => {
      this.assignedReports = res;
      this.isLoading = false;
    });
    this.rmDateRangeService.emitDateRangeUpdate(this.filterStartDate, this.filterEndDate);
  }
}
